import request from '@/utils/request'

export function getIntegratedEmployees(empcd) {
  return request({
    url: `/api/integratedEmployees/` + empcd,
    method: 'get',
  })
}

// export function getIntegratedEmployees(empcd) {
//   return request({
//     url: '/api/integratedEmployees',
//     method: 'get',
//     params: { empcd: empcd },
//   })
// }
